import { useState } from 'react';
import '@/App.css';
import InvoiceGenerator from '@/components/InvoiceGenerator';

function App() {
  return (
    <div className="App min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <InvoiceGenerator />
    </div>
  );
}

export default App;